import cn from 'classnames'
import Icon from 'core/components/icons/Icon'

interface Props {
  title: string
  info: string
  showCheckIcon?: boolean
  isSelected?: boolean
  onClick: VoidFunction
  onEdit?: VoidFunction
  className?: string
}

const FundingMethodItem = ({
  title,
  info,
  showCheckIcon,
  isSelected,
  onClick,
  onEdit,
  className
}: Props) => {
  return (
    <div
      className={cn(
        'flex justify-between items-center border border-dark-1 rounded-md px-5 py-4 hover:border-primary group cursor-pointer',
        isSelected ? 'border-primary' : '',
        className
      )}
      onClick={onClick}
    >
      <div className="flex items-center gap-2">
        <div
          className={cn(
            'flex justify-center items-center border border-dark-2 rounded-full w-4 h-4 group-hover:border-primary',
            isSelected ? '!border-primary bg-primary' : ''
          )}
        >
          {isSelected && <Icon name="check" color="text-white" size={7} />}
        </div>
        <span className="subtitle-1 font-medium">{title}</span>
        {isSelected && (
          <Icon
            name="edit"
            color="text-primary"
            size={16}
            className="cursor-pointer hover:text-primary-3"
            onClick={onEdit}
          />
        )}
      </div>
      <div className="text-dark-4 flex items-center gap-1">
        {showCheckIcon && <Icon name="check" />}
        <span>{info}</span>
      </div>
    </div>
  )
}

export default FundingMethodItem
